export default {
  getHead: () => {
    return [{ name: '회사명' }, { name: '평가차수' }, { name: '대공정' }, { name: '중공정' }, { name: '실시기간' },  { name: '작성자' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContent(value).inputB_1 // 평가차수
      case 2: return func.getContent(value).inputB_4 // 대공정
      case 3: return func.getContent(value).inputB_5 // 중공정
      case 4: return `${func.getContent(value).inputB_2}~${func.getContent(value).inputB_3}` // 공사기간
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      case 6: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '회사명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '평가차수': return ['content$body.inputB_1*%[:default_skw]%']
    case '대공정': return ['content$body.inputB_4*%[:default_skw]%']
    case '중공정': return ['content$body.inputB_5*%[:default_skw]%']
    case '소속명': return ['content$body.stdInfo.department*%[:default_skw]%']
    case '부서명': return ['content$body.stdInfo.com_name*%[:default_skw]%']
    case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }
    return []
  },
}
